module.exports = __webpack_public_path__ + "static/media/version.da2d5c0d.txt";


//////////////////
// WEBPACK FOOTER
// ./src/data/version.txt
// module id = 809
// module chunks = 0